import React, { useState, type JSX } from 'react';

import ConfirmationDialogBox, { ConfirmationDialogLabels } from 'components/ConfirmationDialogBox';

export default function useConfirmationDialogBox() {
  const [open, setOpen] = useState(false);
  const [body, setBody] = useState<JSX.Element>();
  const [confirm, setConfirm] = useState(() => () => {});
  const defaultDismiss = () => setOpen(false);
  const [dismiss, setDismiss] = useState(() => defaultDismiss);
  const [labels, setLabels] = useState<ConfirmationDialogLabels>({});

  /**
   * Abre (ou fecha) o diálogo. `newLabels` é opcional e vale só para esta abertura: sem ele, o
   * diálogo fica sem título e com os botões "Cancelar" / "Sim" de sempre.
   */
  const setConfirmationDialogBox = (
    newOpen: boolean,
    newBody: JSX.Element,
    newConfirm: () => void,
    newDismiss: () => void = defaultDismiss,
    newLabels: ConfirmationDialogLabels = {},
  ) => {
    setOpen(newOpen);
    setBody(newBody);
    setConfirm(() => newConfirm);
    setDismiss(() => newDismiss);
    setLabels(newLabels);
  };

  const confirmationDialogBox = (
    <ConfirmationDialogBox
      open={open}
      confirm={confirm}
      dismiss={dismiss}
      title={labels.title}
      confirmLabel={labels.confirmLabel}
      dismissLabel={labels.dismissLabel}
    >
      {body}
    </ConfirmationDialogBox>
  );

  return {
    setConfirmationDialogBox,
    confirmationDialogBox,
  };
}
